var map = {
	"./pages/apiKeysPage/popupChunks/confirmDelete.popup-chunk.vue": "2197",
	"./pages/apiKeysPage/popupChunks/onBuddyDelete.popup-chunk.vue": "1ed9",
	"./pages/apiKeysPage/popupChunks/onCreateKey.popup-chunk.vue": "6d68",
	"./pages/bonus/popupChunks/bonusRules.popup-chunk.vue": "2136",
	"./pages/buddy/popupChunks/buddyApiKeysCreate.popup-chunk.vue": "9950",
	"./pages/buddy/popupChunks/exitBuddy.popup-chunk.vue": "847a",
	"./pages/leveragesPage/popupChunks/letDeleteFolder.popup-chunk.vue": "1c1e",
	"./pages/leveragesPage/popupChunks/multiAssetToggler.popup-chunk.vue": "97b5",
	"./pages/mainPage/popupChunks/enableMultiAssetModeConfirm.popup-chunk.vue": "ce3a",
	"./pages/mainPage/popupChunks/mulitAssetsInfo.popup-chunk.vue": "ead1",
	"./pages/mainPage/popupChunks/updatingDocument.popup-chunk.vue": "a967",
	"./pages/spotPage/popupChunks/massConvertConfirmSpot.popup-chunk.vue": "2d06",
	"./pages/spotPage/popupChunks/massSellConfirmSpot.popup-chunk.vue": "7520",
	"./pages/spotPage/popupChunks/singleConvertConfirmSpot.popup-chunk.vue": "fe40",
	"./pages/transfersPage/popupChunks/amountRange.popup-chunk.vue": "68fb",
	"./pages/transfersPage/popupChunks/confirmSecretCodeToShowAddresses.popup-chunk.vue": "ba50",
	"./pages/transfersPage/popupChunks/confirmTransfer.popup-chunk.vue": "b6ef9",
	"./pages/transfersPage/popupChunks/qrZoom.popup-chunk.vue": "8226",
	"./pages/transfersPage/popupChunks/setOptimalLeverages.popup-chunk.vue": "74cd",
	"./pages/transfersPage/popupChunks/walletSecret2FA.popup-chunk.vue": "bb6d",
	"./pages/transfersPage/popupChunks/widthdrawConfirmWalletSecretYubikey.popup-chunk.vue": "0e3b",
	"./pages/whitelists/main/popupChunks/confirmActionPopup.popup-chunk.vue": "9545",
	"./pages/whitelists/main/popupChunks/confirmWhitelistRepeat.popup-chunk.vue": "dbd2",
	"./pages/whitelists/main/popupChunks/createSecret.popup-chunk.vue": "7667",
	"./pages/whitelists/main/popupChunks/createSecretConfirmSMS.popup-chunk.vue": "46ae",
	"./pages/whitelists/main/popupChunks/setUpNewSecret.popup-chunk.vue": "e14a",
	"./pages/whitelists/resolveNetworks/popupChunks/confirmSecretCode.popup-chunk.vue": "9a65",
	"./pages/whitelists/resolveNetworks/popupChunks/leaveWhitelistsEditingConfirm.popup-chunk.vue": "9bb1",
	"./popupChunks/YubikeyConnection.popup-chunk.vue": "e773",
	"./popupChunks/YubikeyError.popup-chunk.vue": "f81d",
	"./popupChunks/confirmEmail.popup-chunk.vue": "d933",
	"./popupChunks/confirmGA.popup-chunk.vue": "34ab",
	"./popupChunks/confirmSMS.popup-chunk.vue": "ccc1",
	"./popupChunks/emailGAConfirm.popup-chunk.vue": "5d7b",
	"./popupChunks/emailSMSConfirm.popup-chunk.vue": "af7e",
	"./popupChunks/greeting.popup-chunk.vue": "8827",
	"./popupChunks/improveSafety.popup-chunk.vue": "05dc",
	"./popupChunks/walletSecretConfirm.popup-chunk.vue": "2b07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "48c5";